import A7ProductsModel from "../../models/products/A7ProductsModel";
import configuration from "../../utilities/configuration";
import * as EffectUtility from "../../utilities/EffectUtility";

export async function requestProducts() {
    const endpoint = configuration.apiServer + configuration.apiA7ProductsInfo;
    return EffectUtility.getToModel(A7ProductsModel, endpoint, {}, false);
}
